import { Component,  OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { MessageService } from 'primeng/api';
import { LanguageService } from 'src/app/_services/language.service';
import { FormlyFormOptions } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { UploadEvent } from 'primeng/fileupload';


@Component({
  selector: 'app-doctemplate-edit',
  templateUrl: './doctemplate-edit.component.html',
  styleUrl: './doctemplate-edit.component.scss',
  providers: [MessageService],
})
export class DoctemplateEditComponent implements OnInit {
 
  form = new FormGroup({});
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  urlapi:string='';
  pageTitle:string="Nuovo template";
  backUrl:string='/doctemplates';
  action:any='';
  model:any={
    id:0,
    description:'',
    organization:''
  };
  loading:boolean = true;
 
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    public lang :LanguageService,

  ) { }

  ngOnInit(): void {
    this.urlapi=this.globalService.endpoint+'app/doctemplate_upload';
    let modulefields=this.globalService.configModules.filter((m)=>m.name=='doctemplates');
    this.tabsFields=modulefields[0].tabsFields;

    this.action=this.route.snapshot.paramMap.get('action');
  

    if(this.route.snapshot.paramMap.get('id')){
      this.pageTitle="Modifica template";
      this.apiService.post('app/doctemplates_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        
        
        this.loading=false;

      });
    } else {
     
      
      this.loading=false;
    }
 

    
  }
  
  onBeforeSend(event:any) {
       event.xhr.setRequestHeader("Authorization", `Bearer ${this.globalService.getToken()}`);
      
  }
  
  onUpload(event:any){
   
    this.model.id=event.originalEvent.body[0];

  }


  save(){
    
    this.model['loggedUser']=this.globalService.getUser().id;
    this.apiService.post('app/doctemplates_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      setTimeout(()=>{
        this.router.navigateByUrl(this.backUrl);
      },2000);
    
    });

  }

  

  
  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  

  
  
  
  
}
